import { getHeifDecoder } from './libheif';
import { isHeic } from './utils/is-heic.fn';

let hasImported = false;

onmessage = (
  e: MessageEvent<{
    arrayBuffer: ArrayBuffer;
    b: string;
    file: { name: string; size: number };
    isProd: boolean;
  }>
) => {
  try {
    if (!hasImported) {
      importScripts(`/js/vendor/libheif.js?b=${e.data.b}`);
      hasImported = true;
    }

    if (!isHeic(new Uint8Array(e.data.arrayBuffer.slice(0, 24)))) {
      throw new Error('not_heif');
    }

    const decoder = getHeifDecoder();
    const data = decoder.decode(e.data.arrayBuffer);

    if (!data.length) {
      throw new Error('HEIF image not found');
    }

    const image = data[0];
    const width = image.get_width();
    const height = image.get_height();

    image.display(
      {
        data: new Uint8ClampedArray(width * height * 4),
        width,
        height,
      } as any,
      (displayData) => {
        if (!displayData) {
          throw new Error('HEIF processing error');
        }

        // get the ArrayBuffer from the Uint8Array
        postMessage({ displayData });
      }
    );
  } catch (error) {
    postMessage({
      dispayData: undefined,
      error: (error as any)?.message ?? error?.toString(),
    });
  }
};
